export const OptionsText = 'Options Watchlist' 

export const InitialPrice = 'Initial Price'

export const lastPrice = 'Last Price'

export const StockWatchList = 'Stock Watchlist'


export const FavouriteTicker = 'My Watchlist'


export const fourMin = "Watchlists are updated every four minutes. After the time period, you can access your Watchlist on the Home Page. Please be patient."


export const headingOne = 'To Add a Stock to your Watchlist'
export const ParaOne = '1. Enter Ticker. Do NOT include spaces'
export const paraTwo = '2. Click the GO button to add the stock'
export const headingTwo  = 'To Delete a Stock From your Watchlist'
export const paraThree  = '1. Find the Ticker on  your Watchlist'

export const paraFour  = '2. Check the Box'
export const paraFive   = '3. Click the Garbage Can Icon to Delete'

export const headingThree = 'Where to Use Your Watchlist'
export const paraSix = '1. Click the Home Page'
export const ParaSeven = '2. In the "Group" dropdown,select "My Watchlist" '


// WEBPACK FOOTER //
// ./src/Pages/WatchList/constants.js